// PROP-TNT-REL-CHK
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult } from '../rules';
import IsLoanCategoryEqualTo from '../rules/IsLoanCategoryEqualTo';
import { LoanCategory } from '../../../../../../../../../../types/api';
import SystemPropertyHasRelatedTenants from '../rules/SystemPropertyHasRelatedTenants';

class PropertyTenantWillingToBeCommercialGuarantorRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isAnyPropCoArchetype =
      IsLoanCategoryEqualTo.setCategory(
        LoanCategory.EXPRESS_PLUS_PROPCO
      ).evaluate(data) ||
      IsLoanCategoryEqualTo.setCategory(LoanCategory.CORE_PROPCO).evaluate(
        data
      );
    const systemPropertyHasRelatedTenants =
      SystemPropertyHasRelatedTenants.evaluate(data);

    return isAnyPropCoArchetype && systemPropertyHasRelatedTenants
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PropertyTenantWillingToBeCommercialGuarantorRuleset();
